export interface GuestIdentity {
  name: string;
  generated: boolean;
  chosen: boolean;
}

const KEY = "chesshotel:guest-name:v1";
let memory: GuestIdentity | null = null;
export const legacyDefaultGuest = (name: string) => /^Guest[A-Za-z0-9]{8}(?:\d+)?$/.test(name);

export function readGuestIdentity(): GuestIdentity | null {
  if (typeof window === "undefined") return null;
  try {
    // A tab's current identity wins over the last name used in another tab.
    const sessionName = window.sessionStorage.getItem("guestUsername")?.replace(/^G\*/, "");
    const raw = window.sessionStorage.getItem(KEY) || window.localStorage.getItem(KEY);
    const saved = raw ? JSON.parse(raw) : null;
    if (sessionName && sessionName !== saved?.name) {
      return legacyDefaultGuest(sessionName) ? null : { name: sessionName, generated: false, chosen: true };
    }
    if (typeof saved?.name === "string" && saved.name.trim() && saved.name.length <= 18) {
      return { name: saved.name, generated: saved.generated === true, chosen: saved.chosen === true };
    }
  } catch { /* Optional browser storage. */ }
  return memory;
}

export function rememberGuestIdentity(identity: GuestIdentity) {
  memory = identity;
  if (typeof window === "undefined") return;
  for (const storage of ["sessionStorage", "localStorage"] as const) {
    try { window[storage].setItem(KEY, JSON.stringify(identity)); } catch { /* Session fallback. */ }
  }
  try { window.sessionStorage.setItem("guestUsername", `G*${identity.name}`); } catch { /* Optional storage. */ }
}

export function clearStoredGuestIdentity() {
  memory = null;
  if (typeof window === "undefined") return;
  try { window.sessionStorage.removeItem("guestUsername"); window.sessionStorage.removeItem(KEY); } catch {}
  try { window.localStorage.removeItem(KEY); } catch {}
}
